/* eslint-disable */
export default {
  mute: 'Silenciar',
  unmute: 'Reactivar',
  hangup: 'Colgar',
  reject: 'Rechazar',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
